module.exports = __webpack_public_path__ + "static/media/IntroToWebDevelopment.7f57888d.png";